module.exports = __webpack_public_path__ + "img/mongodb.76cd7770.svg";